import { render, staticRenderFns } from "./drawer-h5-preview.vue?vue&type=template&id=8aad1fba&scoped=true"
import script from "./drawer-h5-preview.vue?vue&type=script&lang=js"
export * from "./drawer-h5-preview.vue?vue&type=script&lang=js"
import style0 from "./drawer-h5-preview.vue?vue&type=style&index=0&id=8aad1fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aad1fba",
  null
  
)

export default component.exports